import React, { useState } from "react";
import { isMobile } from "../../../utils/helper";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { DatePicker, Input, Select } from "antd";
import dayjs from "dayjs";
import ChantSwitch from "../../../CommonComponents/ChantSwitch/ChantSwitch";

const PurchasesFilters = ({
  onFilterChange,
  filters,
  types,
  filterPackages,
}) => {
  const { RangePicker } = DatePicker;

  const [filtersExpanded, setFiltersExpanded] = useState(false);

  return (
    <div id="purchase-filter" style={{ marginTop: "2px" }}>
      {isMobile() ? (
        <div
          className="purchase-filters-header"
          onClick={() => setFiltersExpanded((prev) => !prev)}
          style={filtersExpanded ? { borderRadius: "0%" } : undefined}
        >
          <span>Filters</span>
          {filtersExpanded ? (
            <UpOutlined style={{ marginLeft: "auto" }} />
          ) : (
            <DownOutlined style={{ marginLeft: "auto" }} />
          )}
        </div>
      ) : null}

      {(filtersExpanded || !isMobile()) && (
        <div
          className="purchases-filter-container"
          style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}
        >
          <div
            style={{
              marginRight: "12px",
            }}
          >
            <Input
              value={filters.search}
              onChange={(e) => onFilterChange("search", e.target.value)}
              name="search"
              placeholder="Search name / email"
              style={{ color: "black", fontSize: 16, padding: "0px 15px" }}
            />
          </div>

          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <div>
              <ChantSwitch
                label="Subscriptions Only"
                checked={filters.isSubscription}
                onChange={(checked) => {
                  onFilterChange("isSubscription", checked);
                }}
              />
            </div>

            <div>
              <Select
                value={filters.packageId || undefined}
                onChange={(value) => onFilterChange("packageId", value)}
                options={(filterPackages || []).map((p) => ({
                  value: p.key,
                  label: p.value,
                }))}
                placeholder="Package"
                allowClear
                style={{ width: "200px" }}
              />
            </div>
            <div>
              <Select
                value={filters.type || undefined}
                onChange={(value) => onFilterChange("type", value)}
                options={(types || []).map((t) => ({
                  value: t.key,
                  label: t.type,
                }))}
                placeholder="Type"
                allowClear
                style={{ width: "200px" }}
              />
            </div>
            <div>
              <RangePicker
                tabIndex="2"
                disabledDate={(current) =>
                  current && current > dayjs().endOf("day")
                }
                onChange={(value) => {
                  onFilterChange("dateRange", value);
                }}
                className="col"
                size={15}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchasesFilters;
